import Text from '../../../components/Text';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import Button from '../../../components/Button';
import Image from '../../../constants/images';
import ImagesSlide from '../../../components/ImagesSlide';
import CustomCheckbox from '../../../components/CustomCheckbox';
import { useState } from 'react';
import icons from '../../../constants/icons';
import CustomInput from '../../../components/CustomInput';
import ErrorText from '../../../components/ErrorText';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Typography from '@mui/material/Typography';
import SubscribeCard from './SubscribeCard';
import { subscribeCardData } from '../../../config/config';
import ViewReverse from '../../../components/ViewReverse';
import { rowReverseStylemd } from '../../../utils/styles';
import { ReactSVG } from 'react-svg';
import Chips from '../../../components/Chips';
import { useSelector } from 'react-redux';
import { getContentKeyAccToLang } from '../../../utils/utils';

const FormFundSubscribe = () => {
  const { TextWeight, isArabic } = dynamicfunction();
  const { fundsContent } = useSelector((state) => state.content);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      fundsContent?.web_funds_subscribe?.data?.attributes,
      key,
      isArabic
    );
  };

  const transactionTypes = [getContentKey('cash_account'), getContentKey('in_kind')];
  
  const [hasReadReport, setHasReadReport] = useState(false);
  const [hasAgreedToNDA, setHasAgreedToNDA] = useState(false);
  const [hasAgreedToFinancialsNDA, setHasAgreedToFinancialsNDA] = useState(false);
  const [hasAgreedToTerms, setHasAgreedToTerms] = useState(false);
  const [selectedType, setSelectedType] = useState(transactionTypes[0]);
  
  const [values, setValues] = useState({
    subscriptionAmount: '',
    fundAmount: '',
  });
  const [errors, setErrors] = useState({
    subscriptionAmount: '',
    fundAmount: '',
  });

  return (
    <div className='mt-2'>
      <ViewReverse>
        <div className='w-full sm:w-1/2'>
          <CustomInput
            // label={getContentKey('fund_sar')}
            placeholder={getContentKey('fund_placeholder')}
            isRounded
            type='number'
            value={values.fundAmount}
            onChange={(e) => {
              setValues({ ...values, fundAmount: e.target.value });
            }}
            isError={!!errors.fundAmount}
            isRequired
            divClasses={'self-end'}
          />
          <ErrorText text={errors.fundAmount} />
        </div>
      </ViewReverse>

      <div className='mt-4'>
        <SubscribeCard
          item={subscribeCardData}
          isSubscribe={false}
        />
      </div>

      <Text
        text={
          <>
            {getContentKey('suitibility_report')}{' '}
            <Text
              text={getContentKey('view_report')}
              size={fontSizes.h14}
              weight={TextWeight.semiBold}
              color='text-primary underline'
              className={'inline cursor-pointer'}
            />
          </>
        }
        size={fontSizes.h14}
        weight={TextWeight.light}
        isTruncate={false}
        className={'mt-4'}
      />

      <CustomCheckbox
        isChecked={hasReadReport}
        onClick={() => setHasReadReport(!hasReadReport)}
        label={getContentKey('suitibility_report_acknowledgement')}
        className={'mt-4'}
      />

      <ViewReverse className={`gap-5 mt-6 flex-col ${rowReverseStylemd(isArabic)}`}>
        <div className='flex flex-col justify-between rounded-2xl border border-grey p-2.5 sm:p-3 w-full'>
          <Text
            text={getContentKey('teaser')}
            size={fontSizes.h14}
            weight={TextWeight.semiBold}
            color='text-black'
          />
          <ViewReverse className='gap-3'>
            <ViewReverse className='justify-center items-center gap-3 border border-primary rounded-lg py-2 px-5'>
              <ReactSVG src={icons?.view_icon} />
              <Text
                text={getContentKey('view')}
                color='text-primary'
                isTruncate={false}
              />
            </ViewReverse>
            <ViewReverse className='justify-center items-center gap-3 border border-primary rounded-lg py-2 px-5'>
              <ReactSVG src={icons?.download_icon} />
              <Text
                text={getContentKey('download')}
                color='text-primary'
                isTruncate={false}
              />
            </ViewReverse>
          </ViewReverse>
        </div>

        <div className='rounded-2xl border border-grey p-2.5 sm:p-3 w-full'>
          <Text
            text={getContentKey('presentation')}
            size={fontSizes.h14}
            weight={TextWeight.semiBold}
            color='text-black'
          />
          <Text
            text={
              <>
                {getContentKey('please_agree')}{' '}
                <Text
                  text={getContentKey('non_disclosure_agreement')}
                  color='text-primary underline text-primary'
                  className={'inline'}
                />{' '}
                {getContentKey('view_presentation')}
              </>
            }
            size={fontSizes.h12}
            weight={TextWeight.light}
            color='text-text-grey'
            isTruncate={false}
            className={'mt-3'}
          />
          <CustomCheckbox
            isChecked={hasAgreedToNDA}
            onClick={() => setHasAgreedToNDA(!hasAgreedToNDA)}
            label={getContentKey('i_agree')}
            className={'mt-4'}
          />
        </div>

        <div className='rounded-2xl sm:rounded-2xl border border-grey p-2.5 sm:p-3 w-full'>
          <Text
            text={getContentKey('financials')}
            size={fontSizes.h14}
            weight={TextWeight.semiBold}
            color='text-black'
          />
          <Text
            text={
              <>
                {getContentKey('please_agree')}{' '}
                <Text
                  text={getContentKey('non_disclosure_agreement')}
                  color='text-primary underline text-primary'
                  className={'inline'}
                />{' '}
                {getContentKey('view_financials')}
              </>
            }
            size={fontSizes.h12}
            weight={TextWeight.regular}
            color='text-silver'
            isTruncate={false}
            className={'mt-4'}
          />
          <CustomCheckbox
            isChecked={hasAgreedToFinancialsNDA}
            onClick={() => setHasAgreedToFinancialsNDA(!hasAgreedToFinancialsNDA)}
            label={getContentKey('i_agree')}
            className={'mt-4'}
          />
        </div>
      </ViewReverse>

      <div className='pt-2 sm:pt-4'>
        <Chips
          options={transactionTypes}
          onClick={(type) => setSelectedType(type)}
          selectedType={selectedType}
          label={getContentKey('transaction_type')}
        />
      </div>

      <ViewReverse>
      <div className='w-full sm:w-1/2 pt-2 sm:pt-4'>
        <CustomInput
          label={getContentKey('subscription_amount')}
          placeholder={getContentKey('amount_placeholder')}
          isRounded
          type='number'
          value={values.subscriptionAmount}
          onChange={(e) => {
            const amount = e.target.value;
            setValues((prev) => ({ ...prev, subscriptionAmount: amount }));
          }}
          isError={!!errors.subscriptionAmount}
          isRequired
        />
        <ErrorText text={errors.subscriptionAmount} />
      </div>
      </ViewReverse>

      <ViewReverse className='items-center gap-2 pt-2 sm:pt-4'>
        <Text
          text={getContentKey('suffiecient_amount')}
          size={fontSizes.h14}
          color='text-red'
        />
      </ViewReverse>

      <div className='py-2 sm:py-4'>
        <Text
          text={getContentKey('fee_disclaimer')}
          size={fontSizes.h14}
          weight={TextWeight.regular}
          color='text-silver'
          isTruncate={false}
        />
      </div>

      <CustomCheckbox
        isChecked={hasAgreedToTerms}
        onClick={() => setHasAgreedToTerms(!hasAgreedToTerms)}
        label={
          <>
            {getContentKey('understand_agree')}{' '}
            <Text
              text={getContentKey('agree_term')}
              color='text-primary underline text-primary'
              isTruncate={false}
              className={'inline'}
            />
          </>
        }
      />

      <div className='border-t border-grey h-1 mt-3 w-full'></div>

      <ViewReverse className='gap-2 sm:gap-3 sm:pl-5'>
        <Button
          text={getContentKey('review_btn')}
          bgColor='bg-primary'
          className={'w-full sm:w-fit px-10 rounded-lg capitalize py-2 mt-2 sm:mt-4 text-center border border-orange'}
        />
        <Button
          text={getContentKey('clear_btn')}
          bgColor='bg-white'
          color='text-primary'
          className={'w-full sm:w-fit px-16 rounded-lg capitalize py-2 sm:mt-4 text-center border border-primary'}
        />
      </ViewReverse>
    </div>
  );
};
export default FormFundSubscribe;
